import { render, staticRenderFns } from "./AdsDetail.vue?vue&type=template&id=290aa40a&scoped=true&"
import script from "./AdsDetail.vue?vue&type=script&lang=js&"
export * from "./AdsDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "290aa40a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('290aa40a')) {
      api.createRecord('290aa40a', component.options)
    } else {
      api.reload('290aa40a', component.options)
    }
    module.hot.accept("./AdsDetail.vue?vue&type=template&id=290aa40a&scoped=true&", function () {
      api.rerender('290aa40a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/Ad/AdsDetail.vue"
export default component.exports